import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
export var CardLink = styled(AppLink).withConfig({
  displayName: "CardLink",
  componentId: "sc-12vg325-0"
})(["color:currentColor;text-align:center;"]);